import type { Offre } from '../types/offres';

/**
 * Règles pour les moins de 18 ans (décision du 03/10/2026) : une ALERTE sur les offres qui semblent
 * relever d'un travail interdit ou encadré pour un mineur, jamais un filtre. France Travail ne porte
 * aucun indicateur de ce genre : masquer une offre ferait croire à une garantie qu'on ne peut pas
 * donner. Le repérage est volontairement étroit — des expressions, pas des mots isolés — pour ne pas
 * alerter sur « une hauteur de vue » ou « un bar à salades ».
 */
export type AlerteMineur = 'nuit' | 'alcool' | 'hauteur';

const MOTIFS: Record<AlerteMineur, RegExp> = {
  nuit: /travail de nuit|horaires? de nuit|(poste|equipe|service) de nuit|\b(22|23) ?h\b|minuit/,
  alcool: /barman|barmaid|barmen|debit de boissons?|boissons? alcoolisees?|\balcool|bar a cocktails?|serveu(r|se) en bar|caviste|sommelier/,
  hauteur: /trava(il|ux) en hauteur|echafaudage|cordiste|harnais|nacelle/,
};

const normaliser = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Âge révolu à la date donnée ; null sans date de naissance exploitable. */
export function ageAu(naissance: string | null | undefined, maintenant: Date): number | null {
  const m = naissance ? /^(\d{4})-(\d{2})-(\d{2})/.exec(naissance) : null;
  if (!m) return null;
  const [annee, mois, jour] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const avantAnniversaire =
    maintenant.getUTCMonth() + 1 < mois || (maintenant.getUTCMonth() + 1 === mois && maintenant.getUTCDate() < jour);
  return maintenant.getUTCFullYear() - annee - (avantAnniversaire ? 1 : 0);
}

export function alertesMineur(offre: Offre, age: number | null): AlerteMineur[] {
  if (age === null || age >= 18) return [];
  const texte = normaliser([offre.titre, offre.description, ...offre.details.map((d) => d.valeur)].join(' \n '));
  return (Object.keys(MOTIFS) as AlerteMineur[]).filter((cle) => MOTIFS[cle].test(texte));
}
